import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { goToStep, goToPrevStep, goToNextStep } from '../Form/actionCreator';
import { getStep } from '../Form/selectors';
import { getIsFetching } from '../App/selectors';

import { scrollToForm } from '../../utils/scroll';

class FormButton extends Component {
	handleBack() {
    return (e) => {
			e.preventDefault();
			this.props.goToPrevStep();
			scrollToForm();
		};
	}

	render() {
		const { t, stopNext } = this.props;

		return <>
			<div className='row'>
				<div className='col-2 d-none d-md-block'>
					{this.props.step > 1 ?
						<button className='btn btn-sm btn-outline-secondary my-2 text-uppercase' disabled={this.props.isFetching || this.props.isTestCase} onClick={this.handleBack()} type='button'>{t('form.buttons.back')}</button>
						: ''
					}
				</div>
				<div className='col-sm-6 offset-sm-3 offset-md-1 d-grid gap-2'>
					{this.props.lastStep ?
						<button className='btn btn-success my-2 text-uppercase' disabled={this.props.isFetching} onClick={this.props.onSubmit}>{t('form.buttons.activate')}</button>
						: <button className='btn btn-success my-2 text-uppercase' type='submit' disabled={stopNext}>{t('form.buttons.next')}</button>
					}
				</div>
				<div className='col-3 d-none d-sm-block'></div>
				<div className='col-2 d-none d-md-block'></div>
				<div className='col-sm-6 offset-sm-3 d-block d-md-none d-grid gap-2'>
					{this.props.step > 1 ?
						<button className='btn btn-outline-secondary my-2 text-uppercase' disabled={this.props.isFetching || this.props.isTestCase} onClick={this.handleBack()} type='button'>{t('form.buttons.back')}</button>
						: ''
					}
				</div>
			</div>
		</>;
	}
}

const mapStateToProps = (state) => {
	return {
		step: getStep(state),
		isFetching: getIsFetching(state),
		isTestCase: state.get('isTestCase', false)
	};
};

const mapDispatchToProps = {
	goToStep,
	goToPrevStep,
	goToNextStep
};

FormButton.propTypes = {
	step: PropTypes.number,
	isFetching: PropTypes.bool,
	isTestCase: PropTypes.bool,
	lastStep: PropTypes.bool,
	t: PropTypes.func,

	goToStep: PropTypes.func,
	goToPrevStep: PropTypes.func,
	goToNextStep: PropTypes.func,
	stopNext: PropTypes.bool,

	onSubmit: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(FormButton);
